<template>
  <div>
    <loader v-if="isLoading"></loader>
    <div
      v-else
      :class="{
        'opacity-50 cursor-not-allowed': ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '2'
      }"
    >
      <h2 v-if="!application" class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b">
        Est-ce que vous êtes
      </h2>
      <div v-if="!application" class="form-control relative mb-5">
        <sp-radio
          theme="team"
          v-model="type"
          v-for="(op, index) in [
            { name: 'Personne physique', value: 'physic' },
            { name: 'Personne morale', value: 'moral' },
            { name: 'Organisme de Placement Collectif en Valeurs Mobilières', value: 'fond' }
          ]"
          :key="index"
          :value="op.value"
          :name="'radio' + index + 'choice'"
          :id="'radio' + index + 'choice'"
          :disabled="ecosystemApp && ecosystemApp.application && ecosystemApp.application.status != '0' && ecosystemApp.application.status != '11'"
          >{{ op.name }}</sp-radio
        >
      </div>
      <PhysicalPersonForm
        v-if="type == 'physic'"
        :formData="formData"
        :application="application"
        :type="type"
      ></PhysicalPersonForm>
        <FundsMoral v-else :type="type" :formData="formData" :application="application"></FundsMoral>
    </div>
  </div>
</template>
<style>
.form-control--icon2 {
  top: 1.9rem;
  left: 0.05rem;
  height: 2.7rem;
}

.g-education .card-a:last-child,
.g-experience .card-a:last-child {
  border: none;
}
.loader {
  height: 100px;
  width: 80%;
  text-align: center;
  padding: 1em;
  margin: 0 auto 1em;
  display: inline-block;
  vertical-align: top;
}
.loader svg path,
.loader svg rect {
  fill: #ff6700;
}

.card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  width: 40%;
}

.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.card.container {
  padding: 2px 16px;
}

.bg-red-lighter {
  background-color: #fce4e4 !important;
}

.has-error-date,
.has-error input,
.has-error textarea,
.has-error .dropzone.vue-dropzone,
.has-error .checkmark,
.has-error .ui.fluid.dropdown {
  border-color: #a94442 !important;
  background-color: #fce4e4 !important;
}

.date-required:after {
  content: " *";
  color: red;
}
</style>

<script>
import PhysicalPersonForm from "@/views/Investor/PhysicalPersonForm.vue";
import FundsMoral from "@/views/Investor/FundsMoral.vue";
import RadioVue from "../../components/spKit/Radio.vue";
import { FETCH_INVESTOR_FORM,FETCH_SESSIONLESS_APP_BY_APP_TYPE, FETCH_ECOSYSTEM_APPLICATION } from "@/store/actions.type";
import { SET_ECOSYSTEM_MENU_ACTIVE, SET_PROGRESS } from "@/store/mutations.type";
import { mapGetters } from 'vuex';
import Loader from "@/components/Loader.vue";
export default {
  name: "investorForm",
  components: {
    PhysicalPersonForm: PhysicalPersonForm,
    FundsMoral: FundsMoral,
    "sp-radio": RadioVue,
    Loader
  },
  data() {
    return {
      type: "physic",
      formData: {},
      application: {},
      isLoading: true
    };
  },
  mounted() {
    this.$store.dispatch(FETCH_INVESTOR_FORM, this.$route.params.ecoAppId).then(data => {
      this.isLoading = false;
      if (data.data.investorFormData && data.data.investorFormData.type == 'Personne physique') {
        this.type = 'physic';
      } else if (data.data.investorFormData && data.data.investorFormData.type == 'Personne morale') {
        this.type = 'moral';
      } else {
        this.type = 'fond';
      }
      this.formData = data.data.investorFormData;
      this.$store.commit(SET_PROGRESS, data.data.progress);
    });
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, true);
    if(this.$route.params.ecoAppId) {
      this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.ecoAppId);
    }
    this.$store.dispatch(FETCH_SESSIONLESS_APP_BY_APP_TYPE, 'investor').then(data => {
      this.applications = data.data.data.applications;
      // Find the object with matching id
      const matchedApplication = this.applications.find(app => app.user_id === this.currentUser.id);
      if(matchedApplication) 
        this.application = matchedApplication;
      else 
      this.application = this.applications[0];
    })
    .catch(error => {
      console.log(error);
    });
  },
  methods: {},
  computed: {
    ...mapGetters(["ecosystemApp", "currentUser"]),
  }
};
</script>
